import { c as _c } from "react/compiler-runtime";
import { WithCommonProps } from '@types';
import { getDividerStylesAsClassName } from './divider-styles';
export enum DividerVariant {
  GRAY = 'gray',
  WHITE = 'white',
}
export type IDividerProps = WithCommonProps<{
  variant?: DividerVariant;
}>;
export const Divider = t0 => {
  const $ = _c(8);
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      variant: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = t1;
  } else {
    rest = $[1];
    t1 = $[2];
  }
  const variant = t1 === undefined ? DividerVariant.GRAY : t1;
  let t2;
  if ($[3] !== variant) {
    t2 = getDividerStylesAsClassName(variant);
    $[3] = variant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== rest || $[6] !== t2) {
    t3 = <hr className={t2} {...rest} />;
    $[5] = rest;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};